import React from 'react';
import { AutoComplete } from 'antd';

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  options: { label: string; value: string }[];
};

// Suggests known values but accepts any text: tickets can carry types/categories that aren't in the
// categorization tree (e.g. event-generated "RMM" tickets). Blank matches anything.
const MatchValueInput = ({ value, onChange, options }: Props) => (
  <AutoComplete
    value={value}
    onChange={onChange}
    options={options}
    allowClear
    placeholder="Any"
    filterOption={(input, option) =>
      (option?.value ?? '').toLowerCase().includes(input.toLowerCase())
    }
  />
);

export default MatchValueInput;
